import React from "react";

export default function SetHeadline (props) {

    const style = {
        header:{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor:"#BB6BD9",
            position: "fixed",
            zIndex: "999",
            width: "100%",
            height: "40px",
        },
        header_text:{
            fontFamily:"Open Sans Hebrew",
            fontStyle: "normal",
            fontSize: "16px",
            lineHeight: "23px",
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            color: "#FFFFFF",
        }
    };
    let headline;
    headline =  "הרשמה" + " " + props.type;

    return(
        <div style={style.header}>
            <div style={style.header_text}>{headline}</div>
        </div>
    );
}